export default {
  certificates: [],
  profiles: [],
  entrepreneurProfiles: [],
  surveyList: [],
  partnerList: []
}
